import axios from 'axios'
import { site } from '/gateways/rails/site'
import { session } from '/gateways/rails/session'
import { resetPassword } from '/gateways/rails/reset_password'
import { systemInformation } from '/gateways/rails/system_information'

const api = {
  fetchSiteCommon: async () => {
    return site(axios).fetchSiteCommon()
  },
  signIn: async (query) => {
    return session(axios).signIn(query)
  },
  signOut: async () => {
    return session(axios).signOut()
  },
  session: () => session(axios),
  sendResetPasswordEmail: async (query) => {
    return resetPassword(axios).sendResetPasswordEmail(query)
  },
  resetPassword: async (query) => {
    return resetPassword(axios).resetPassword(query)
  },
  fetchSystemInformations: async (query) => {
    return systemInformation(axios).fetchSystemInformations(query)
  },
  readSystemInformation: async (systemInformationId) => {
    return systemInformation(axios).readSystemInformation(systemInformationId)
  }
}
export default api
